import { create } from "zustand";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL1 } from "../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../utils/apiCall";

const useGrievanceReportStore = create((set, get) => ({
    grievanceReportData: [],
    grievanceItemList: [],
    grievanceItemsDropedownList: [],
    loading: false,
    error: false,
    statusFilter: "",
    selectComplaintNo: "",
    selectedStatus: "",
    selectIEName: "",

    setSelectedComplaintNo: (complaintNo) => set({ selectComplaintNo: complaintNo }),
    setStatus: (status) => set({ selectedStatus: status }),
    setSelectedIEName: (IEName) => set({ selectIEName: IEName }),

    fetchgrievanceDetailedReport: async (queryParams) => {
        set({ loading: true, error: null });
        const queryString = new URLSearchParams(queryParams).toString();
        try {
            const grievanceData = await apiCall({
                url: `${API_BASE_URL1}IEMasterDetails/GetAllGrievanceDetails?${queryString}`,
                method: "get",
                token: localStorage.getItem("token"),
            });

            set({
                grievanceReportData: Array.isArray(grievanceData) ? grievanceData : [],
                loading: false
            });

            set((state) => ({
                grievanceItemList: state.grievanceItemList.length ? state.grievanceItemList : grievanceData.map((eng) => eng.complaintNo),
            }));
            set((state) => ({
                grievanceItemsDropedownList: state.grievanceItemsDropedownList.length
                    ? state.grievanceItemsDropedownList
                    : grievanceData.map((eng) => ({
                        id: eng.ieEngineerId,
                        name: eng.ieEngineerName
                    }))
            }));




        } catch (error) {

            if (error.response && error.response.status === 404) {
                set({
                    grievanceReportData: [],
                    // error: "No hygiene observations found.",
                    loading: false
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        } finally {
            set({ loading: false });
        }
    },


    // Update a existing Grievance Data with Validation Handling
    updateGrievanceData: async (updateGrievance) => {
        set({  error: null });

        try {
            const response = await apiCall({
                url: `${API_BASE_URL1}IEMasterCreate/UpdateIeGrievanceDetail`,
                method: "put",
                token: localStorage.getItem("token"),
                data: updateGrievance,
            });

            set((state) => ({
                grievanceReportData: [...state.grievanceReportData, response],
                // loading: false
            }));


            toast.success("IE Grievance Detail Updated Successfully!");
            return { success: true };

        } catch (error) {
            console.error("Error adding Grievance:", error.response?.data || error.message);

            if (error.response?.status === 400) {
                const validationErrors = error.response.data.errors || error.response.data;

                if (typeof validationErrors === "object") {
                    let errorMessages = [];

                    Object.keys(validationErrors).forEach((key) => {
                        if (Array.isArray(validationErrors[key])) {
                            validationErrors[key].forEach((msg) => {
                                errorMessages.push(msg);
                            });
                        } else {
                            errorMessages.push(validationErrors[key]);
                        }
                    });

                    errorMessages.forEach((msg) => toast.error(msg));
                    return { success: false, errors: validationErrors };
                }
            }

            // Handle general errors
            const errorMessage = error.response?.data || "Failed to add Greviance";
            toast.error(errorMessage);
            set({ error: errorMessage, loading: false });

            return { success: false, errors: { general: errorMessage } };
        }
        finally {
            set({ loading: false });
        }
    },
}));

export default useGrievanceReportStore;
